import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Badge,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { IoMdAdd } from 'react-icons/io';
import { MdOutlineFileDownload, MdImage, MdVideocam } from 'react-icons/md';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { FiSend } from 'react-icons/fi';
import { AiOutlineWarning } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { toast } from 'react-toastify';
import { BASEURL } from '../../../../baseUrl';
import {
  getAllCampaigns,
  sendCampaign,
  getTemplates,
  getAllContacts,
  uploadMedia,
  getAllGroups,
  getGroupById,
  getCredentials,
} from '../../../../redux/actions/Chatbox.action';

const campaignModalStyles = `
  .campaign-modal-wide .modal-dialog {
    max-width: 1200px;
    width: 95%;
  }
`;

const EMPTY_ARRAY = [];

export default function Campaigns() {
  const dispatch = useDispatch();
  const chatbox = useSelector((state) => state.chatbox);

  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [language, setLanguage] = useState('en');
  const [fromNumberId, setFromNumberId] = useState('');
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [recipientType, setRecipientType] = useState('contacts');
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [groupDropdownOpen, setGroupDropdownOpen] = useState(false);

  const [showVarsModal, setShowVarsModal] = useState(false);
  const [uploadTargetTemplate, setUploadTargetTemplate] = useState(null);
  const [headerFile, setHeaderFile] = useState(null);
  const [headerPreviewUrl, setHeaderPreviewUrl] = useState('');
  const [headerMediaId, setHeaderMediaId] = useState('');
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [bodyValues, setBodyValues] = useState([]);
  const [templatePage, setTemplatePage] = useState(1);
  const TEMPLATES_PER_PAGE = 6;
  const toggle = () => setShow(!show);

  useEffect(() => {
    if (show) {
      setTemplatePage(1);
    }
  }, [show]);

  useEffect(() => {
    dispatch(getAllCampaigns());
    dispatch(getTemplates({ status: 'APPROVED', limit: 1000 }));
    dispatch(getAllContacts({ page: 1, limit: 500 }));
    dispatch(getAllGroups({ page: 1, limit: 100 }));
    dispatch(getCredentials());
  }, []);

  useEffect(() => {
    if (recipientType === 'groups' && selectedGroupId) {
      dispatch(getGroupById(selectedGroupId));
    }
  }, [recipientType, selectedGroupId]);

  useEffect(() => {
    if (headerFile) {
      const url = URL.createObjectURL(headerFile);
      setHeaderPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setHeaderPreviewUrl('');
  }, [headerFile]);

  const campaignList = chatbox?.getAllCampaigns?.data?.result?.data || [];
  const templateList = chatbox?.getTemplates?.data?.data?.data || [];
  const totalTemplatePages = Math.max(
    1,
    Math.ceil(templateList.length / TEMPLATES_PER_PAGE),
  );
  const paginatedTemplates = templateList.slice(
    (templatePage - 1) * TEMPLATES_PER_PAGE,
    templatePage * TEMPLATES_PER_PAGE,
  );
  const contactList = chatbox?.getAllContacts?.data?.data || EMPTY_ARRAY;
  const totalContactsCount =
    chatbox?.getAllContacts?.data?.totalCount || contactList.length;
  const groupList = chatbox?.getAllGroups?.data?.data || [];
  const groupContacts =
    chatbox?.getGroupById?.data?.data?.contactIds || EMPTY_ARRAY;
  const selectedGroupName =
    groupList.find((g) => g._id === selectedGroupId)?.name || '';
  const registeredPhoneNumber =
    chatbox?.getCredentials?.data?.data?.registerdPhoneNumber || '';

  useEffect(() => {
    if (registeredPhoneNumber) {
      setFromNumberId(registeredPhoneNumber);
    }
    console.log(':::registeredPhoneNumber:::', registeredPhoneNumber);
  }, [registeredPhoneNumber]);

  useEffect(() => {
    if (recipientType === 'contacts') {
      setSelectedContacts(contactList.map((c) => c.phoneNumber));
    } else if (recipientType === 'groups') {
      setSelectedContacts(groupContacts.map((c) => c.phoneNumber));
    }
  }, [recipientType, contactList, groupContacts]);

  const getComponent = (template, type) =>
    template?.components?.find((c) => c.type?.toUpperCase() === type);
  const getHeaderFormat = (template) => {
    const header = getComponent(template, 'HEADER');
    return header?.format?.toUpperCase() || null;
  };

  const isMediaHeader = (template) => {
    const format = getHeaderFormat(template);
    return format === 'IMAGE' || format === 'VIDEO';
  };
  const getBodyVariableCount = (template) => {
    const body = getComponent(template, 'BODY');
    if (!body?.text) return 0;
    const matches = body.text.match(/{{\s*\d+\s*}}/g);
    return matches ? matches.length : 0;
  };
  const getBodyText = (template) => getComponent(template, 'BODY')?.text || '';

  const getVariablePreviewText = (template) => {
    const text = getBodyText(template);
    if (!text) return '';
    return text.replace(/{{\s*(\d+)\s*}}/g, (_, n) => `[Variable ${n}]`);
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    if (template?.language) {
      setLanguage(template.language);
    }
    setHeaderFile(null);
    setHeaderMediaId('');
    const count = getBodyVariableCount(template);
    setBodyValues(Array.from({ length: count }, () => ''));
  };

  const handleOpenUploadModal = (template) => {
    handleTemplateSelect(template);
    setUploadTargetTemplate(template);
    setShowVarsModal(true);
  };

  const handleTemplateChoice = (template) => {
    if (isMediaHeader(template)) {
      handleOpenUploadModal(template);
    } else {
      handleTemplateSelect(template);
    }
  };
  const handleDownloadReport = async (campaign, status) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${BASEURL}/chatbox/campaign/campaignReport/${campaign._id}?status=${status}`,
        { headers: { authorization: `Bearer ${token}` } },
      );
      const result = await res.json();
      const rows = result?.data || [];
      if (!rows.length) {
        toast.error(`No ${status} contacts to download`);
        return;
      }
      const header = 'Contact,Status,WhatsApp Status\n';
      const csv = rows
        .map(
          (r) =>
            `${r.contact || ''},${r.status || ''},${r.whatsappStatus || ''}`,
        )
        .join('\n');
      const blob = new Blob([header + csv], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${campaign.name}_${status}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('Download failed');
    }
  };

  const handleSendCampaign = async () => {
    if (recipientType === 'groups' && !selectedGroupId) {
      toast.error('Please select a group');
      return;
    }
    if (!name || !selectedTemplate || selectedContacts.length === 0) {
      toast.error(
        'Please fill campaign name, select a template and recipients',
      );
      return;
    }
    if (!fromNumberId) {
      toast.error('Please enter From Number');
      return;
    }

    const headerFormat = getHeaderFormat(selectedTemplate);
    const headerNeedsMedia =
      headerFormat === 'IMAGE' || headerFormat === 'VIDEO';
    if (headerNeedsMedia && !headerMediaId) {
      toast.error(
        `Please upload the header ${headerFormat === 'VIDEO' ? 'video' : 'image'} in Add Variables`,
      );
      return;
    }

    setIsLoading(true);

    const parameters = selectedContacts.map(() => {
      const param = {};
      if (headerNeedsMedia && headerMediaId) {
        param.header = {
          type: headerFormat === 'VIDEO' ? 'video' : 'image',
          value: headerMediaId,
          filename:
            headerFile?.name ||
            (headerFormat === 'VIDEO' ? 'video.mp4' : 'image.jpg'),
        };
      }
      if (bodyValues.length > 0) {
        param.body = [...bodyValues];
      }
      return param;
    });

    const payload = {
      name,
      templateId: selectedTemplate.id,
      templateName: selectedTemplate.name,
      language,
      contactGroup: selectedContacts,
      fromNumberId,
      parameters,
    };

    dispatch(sendCampaign(payload)).then(() => {
      setIsLoading(false);
      toggle();
      setName('');
      setSelectedTemplate(null);
      setFromNumberId('');
      setSelectedContacts([]);
      setBodyValues([]);
      setHeaderFile(null);
      setHeaderMediaId('');
      setRecipientType('contacts');
      setSelectedGroupId('');
      setUploadTargetTemplate(null);
    });
  };

  const getStatusBadge = (status) => {
    const colorMap = {
      in_progress: 'green',
      scheduled: 'orange',
      completed: 'blue',
      failed: 'red',
    };
    return (
      <Badge
        colorScheme={colorMap[status] || 'gray'}
        borderRadius="full"
        px="2"
      >
        {status}
      </Badge>
    );
  };

  return (
    <>
      <style>{campaignModalStyles}</style>
      <div className="mt-[100px] d-flex justify-content-end align-items-center flex-wrap gap-3">
        <Button
          onClick={toggle}
          className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
        >
          <IoMdAdd className="mt-1" />
          Create New Campaign
        </Button>
      </div>
      <div className="mt-[30px] mb-4">
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Campaign Name</Th>
                <Th>Created Date</Th>
                <Th>Status</Th>
                <Th>Contacts</Th>
                <Th>Created By</Th>
                <Th>Sent</Th>
                <Th>Failed</Th>
              </Tr>
            </Thead>
            <Tbody>
              {campaignList.length > 0 ? (
                campaignList.map((res) => (
                  <Tr key={res._id}>
                    <Td className="fw-bold">{res.name}</Td>
                    <Td>
                      {moment(res.createdAt).format('DD MMM YYYY, HH:mm')}
                    </Td>
                    <Td>{getStatusBadge(res.status)}</Td>
                    <Td>
                      <span className="d-flex align-items-center gap-1 text-muted">
                        <HiOutlineUserGroup />
                        {res.contactGroup?.length || 0}
                      </span>
                    </Td>
                    <Td>{res.campaign_created_by?.name || '-'}</Td>
                    <Td>
                      <span className="d-flex align-items-center gap-2 text-success">
                        <FiSend />
                        {res.sentCount || 0} Sent
                        <MdOutlineFileDownload
                          className="fs-5 text-primary"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDownloadReport(res, 'sent')}
                          title="Download sent contacts"
                        />
                      </span>
                    </Td>
                    <Td>
                      <span className="d-flex align-items-center gap-2 text-danger">
                        <AiOutlineWarning />
                        {res.failedCount || 0} Failed
                        <MdOutlineFileDownload
                          className="fs-5 text-primary"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDownloadReport(res, 'failed')}
                          title="Download failed contacts"
                        />
                      </span>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={7} textAlign="center">
                    No Campaigns Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      {/* Create Campaign Modal */}
      <Modal
        show={show}
        onHide={toggle}
        size="xl"
        dialogClassName="campaign-modal-wide"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New Campaign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-3 gx-3">
            <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Campaign Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter campaign name"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div>
            {/* <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Campaign Owner Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={ownerName}
                  onChange={(e) => setOwnerName(e.target.value)}
                  placeholder="SmartX CRM"
                  className="shadow-none focus:!border-theme-dark"
                />
              </Form.Group>
            </div> */}
            <div className="col-md-4">
              <Form.Group>
                <Form.Label>From Number</Form.Label>
                <Form.Control
                  type="text"
                  value={fromNumberId}
                  readOnly
                  disabled
                  className="shadow-none focus:!border-theme-dark"
                  style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                />
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Select Recipients</Form.Label>
            <div className="d-flex flex-column gap-2">
              <Form.Check
                type="radio"
                id="recipient-contacts"
                name="recipientType"
                label={`All Contacts (${totalContactsCount})`}
                checked={recipientType === 'contacts'}
                onChange={() => {
                  setRecipientType('contacts');
                  setSelectedGroupId('');
                  setGroupDropdownOpen(false);
                }}
              />
              <Form.Check
                type="radio"
                id="recipient-groups"
                name="recipientType"
                label="All Groups"
                checked={recipientType === 'groups'}
                onChange={() => setRecipientType('groups')}
              />
            </div>
          </Form.Group>

          {recipientType === 'groups' && (
            <Form.Group
              className="mb-3 position-relative"
              style={{ maxWidth: '360px' }}
            >
              <Form.Label>Select Group</Form.Label>
              <div
                className="border rounded d-flex align-items-center justify-content-between px-3 py-2"
                style={{ cursor: 'pointer' }}
                onClick={() => setGroupDropdownOpen((prev) => !prev)}
              >
                <span className={selectedGroupName ? '' : 'text-muted'}>
                  {selectedGroupName || 'Select group'}
                </span>
                <span>▾</span>
              </div>
              {groupDropdownOpen && (
                <div
                  className="border rounded bg-white position-absolute w-100 mt-1 shadow-sm"
                  style={{ zIndex: 10, maxHeight: '220px', overflowY: 'auto' }}
                >
                  {groupList.length > 0 ? (
                    groupList.map((g) => (
                      <div
                        key={g._id}
                        className="px-3 py-2"
                        style={{
                          cursor: 'pointer',
                          background:
                            g._id === selectedGroupId
                              ? '#eef4ff'
                              : 'transparent',
                        }}
                        onClick={() => {
                          setSelectedGroupId(g._id);
                          setGroupDropdownOpen(false);
                        }}
                      >
                        {g.name} ({g.contactIds?.length || 0} contacts)
                      </div>
                    ))
                  ) : (
                    <div className="px-3 py-2 text-muted">No groups found</div>
                  )}
                </div>
              )}
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Select Template</Form.Label>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
              }}
            >
              {paginatedTemplates.map((t) => {
                const headerFormat = getHeaderFormat(t);
                const hasMedia = isMediaHeader(t);
                return (
                  <div
                    key={t.id || t.name}
                    onClick={() => handleTemplateChoice(t)}
                    className="p-3 rounded"
                    style={{
                      border:
                        selectedTemplate?.name === t.name
                          ? '2px solid #0d6efd'
                          : '1px solid #dee2e6',
                      cursor: 'pointer',
                      minWidth: 0,
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2 gap-2">
                      <span
                        className="fw-bold"
                        title={`Name: ${t.name} (${t.language})`}
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        Name: {t.name} ({t.language})
                      </span>
                      <Form.Check
                        type="radio"
                        checked={selectedTemplate?.name === t.name}
                        onChange={() => handleTemplateChoice(t)}
                        style={{ flexShrink: 0 }}
                      />
                    </div>
                    {hasMedia && (
                      <div
                        className="rounded d-flex align-items-center justify-content-center position-relative mb-2"
                        style={{ height: '150px', background: '#eef0f4' }}
                      >
                        {headerFormat === 'VIDEO' ? (
                          <MdVideocam
                            className="text-secondary"
                            style={{ fontSize: '42px' }}
                          />
                        ) : (
                          <MdImage
                            className="text-secondary"
                            style={{ fontSize: '42px' }}
                          />
                        )}
                      </div>
                    )}
                    From NumberFrom Number
                    <p
                      className="mb-0 small"
                      style={{ whiteSpace: 'pre-line' }}
                    >
                      {getBodyText(t)}
                    </p>
                  </div>
                );
              })}
            </div>

            {templateList.length > TEMPLATES_PER_PAGE && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="text-muted small">
                  Page {templatePage} of {totalTemplatePages} (
                  {templateList.length} templates)
                </span>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={templatePage === 1}
                    onClick={() => setTemplatePage((p) => Math.max(1, p - 1))}
                  >
                    ‹ Prev
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={templatePage === totalTemplatePages}
                    onClick={() =>
                      setTemplatePage((p) =>
                        Math.min(totalTemplatePages, p + 1),
                      )
                    }
                  >
                    Next ›
                  </Button>
                </div>
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Language Code</Form.Label>
            <Form.Control
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              placeholder="Auto-filled from selected template"
              className="shadow-none focus:!border-theme-dark"
            />
            <div className="text-muted small">
              Auto-filled when you pick a template above — only change this if
              you know the exact WhatsApp language code (e.g. en_US).
            </div>
          </Form.Group>

          <div className="text-muted small">
            {selectedContacts.length} recipient(s) selected
            {recipientType === 'groups' && selectedGroupName
              ? ` from "${selectedGroupName}"`
              : ''}
            .
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={toggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Close
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => {
              if (selectedTemplate && isMediaHeader(selectedTemplate)) {
                setUploadTargetTemplate(selectedTemplate);
                setShowVarsModal(true);
              } else {
                toast.error(
                  'This template has no image/video header to upload',
                );
              }
            }}
            disabled={!selectedTemplate || !isMediaHeader(selectedTemplate)}
          >
            Add Variables
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSendCampaign}
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Campaign'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Upload IMAGE Modal — matches the template preview + header image upload UI */}
      <Modal
        show={showVarsModal}
        onHide={() => setShowVarsModal(false)}
        centered
      >
        <Modal.Header closeButton className="!bg-theme-dark text-white">
          <Modal.Title>
            {getHeaderFormat(uploadTargetTemplate || selectedTemplate) ===
            'VIDEO'
              ? 'Upload VIDEO'
              : 'Upload IMAGE'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="border rounded p-3 mb-3"
            style={{ background: '#f4f6fb' }}
          >
            <div
              className="text-center text-muted rounded mb-3 d-flex align-items-center justify-content-center"
              style={{ background: '#e2e5ea', minHeight: '90px' }}
            >
              {headerPreviewUrl ? (
                getHeaderFormat(uploadTargetTemplate || selectedTemplate) ===
                'VIDEO' ? (
                  <video
                    src={headerPreviewUrl}
                    controls
                    style={{ maxHeight: '160px', maxWidth: '100%' }}
                  />
                ) : (
                  <img
                    src={headerPreviewUrl}
                    alt="Header preview"
                    style={{ maxHeight: '140px', maxWidth: '100%' }}
                  />
                )
              ) : getHeaderFormat(uploadTargetTemplate || selectedTemplate) ===
                'VIDEO' ? (
                'No video uploaded'
              ) : (
                'No image uploaded'
              )}
            </div>
            <div style={{ whiteSpace: 'pre-line' }}>
              {getVariablePreviewText(uploadTargetTemplate || selectedTemplate)}
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>
              {getHeaderFormat(uploadTargetTemplate || selectedTemplate) ===
              'VIDEO'
                ? 'Choose Video File'
                : 'Choose Image File'}
            </Form.Label>
            <Form.Control
              type="file"
              accept={
                getHeaderFormat(uploadTargetTemplate || selectedTemplate) ===
                'VIDEO'
                  ? 'video/*'
                  : 'image/*'
              }
              onChange={(e) => setHeaderFile(e.target.files?.[0] || null)}
            />
            {headerMediaId && (
              <div className="text-success small mt-1">
                Uploaded — media id: {headerMediaId}
              </div>
            )}
          </Form.Group>

          {bodyValues.length > 0 && (
            <>
              <Form.Label className="fw-bold">Body Variables</Form.Label>
              {bodyValues.map((val, idx) => (
                <Form.Group className="mb-2" key={idx}>
                  <Form.Label>{`{{${idx + 1}}}`}</Form.Label>
                  <Form.Control
                    type="text"
                    value={val}
                    onChange={(e) => {
                      const updated = [...bodyValues];
                      updated[idx] = e.target.value;
                      setBodyValues(updated);
                    }}
                    placeholder={`Value for {{${idx + 1}}} (applied to every recipient)`}
                  />
                </Form.Group>
              ))}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVarsModal(false)}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0"
            disabled={uploadingMedia || !headerFile}
            onClick={async () => {
              setUploadingMedia(true);
              const mediaId = await dispatch(uploadMedia(headerFile));
              setUploadingMedia(false);
              if (mediaId) {
                setHeaderMediaId(mediaId);
                setShowVarsModal(false);
              }
            }}
          >
            {uploadingMedia ? 'Uploading...' : 'Upload'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
